import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const aboutPoster = "https://customer-assets-v7afamib.emergentagent.net/job_right-hire-portal/artifacts/algqxs1l_fa6b8d0b-2c7c-4000-a376-6669bf21e283.png";

export default function AboutPhotoPage() {
  return (
    <main className="page-shell" data-testid="about-page">
      <section className="page-heading about-heading">
        <p className="eyebrow">ABOUT RIGHT HIRE PERSONNEL</p>
        <h1>THE PEOPLE<br />BEHIND THE <span>WORK.</span></h1>
        <p>Right Hire Personnel is an Adelaide recruitment partner built around simple principles: show up, know the work and do right by people.</p>
      </section>
      <section className="about-grid">
        <div className="about-poster-panel" data-testid="about-poster-panel">
          <img src={aboutPoster} alt="Right Hire Personnel building today together" className="about-poster-image" data-testid="about-poster-image" />
        </div>
        <div>
          <p className="section-label">OUR APPROACH</p>
          <h2>RECRUITMENT<br />WITH <span>GRIT.</span></h2>
          <p>We believe labour hire should never feel complicated. We take time to understand your worksite, your team and the standard you expect — then connect you with the people who can meet it.</p>
          <ul>
            {["Local knowledge, Adelaide-wide reach", "Practical screening and ticket checks", "Direct access to a responsive recruitment team"].map((item) => <li key={item} data-testid={`about-value-${item.toLowerCase().replaceAll(" ", "-")}`}><Check size={17} />{item}</li>)}
          </ul>
          <Link className="button-primary" to="/contact" data-testid="about-contact-button">Talk to our team</Link>
        </div>
      </section>
    </main>
  );
}